import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { RankingballotsPageRoutingModule } from './rankingballots-routing.module';

import { RankingballotsPage } from './rankingballots.page';
import { TBrankingModule } from 'src/app/components/tb-ranking/tb-ranking.module';
import { CountdowntModule } from 'src/app/components/countdown/countdown.module';
//import { TBrankingModule } from 'src/app/components/tb-ranking/tb-ranking.module';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RankingballotsPageRoutingModule,
    TBrankingModule,
    CountdowntModule
  ],
  declarations: [RankingballotsPage]
})
export class RankingballotsPageModule {}
